import {
    createContext,
    useContext,
    useCallback,
} from 'react';
import { useTranslation as useTranslate } from 'react-i18next';

const TranslationContext = createContext({
    t: () => {},
});

export const useTranslation = () => (
    useContext(TranslationContext)
);

export const TranslationProvider = ({ children }) => {
    const { t } = useTranslate();
    const translate = useCallback(
        (...rest) => t(...rest),
        [t],
    );

    return (
        <TranslationContext.Provider value={{
            t: translate,
        }}>
            {children}
        </TranslationContext.Provider>
    );
};
